// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .submitClass {
  cursor: pointer;
  width: 30px;
  height: 20px;
  border: 1px solid var(--sdk-chat-widow-primary-blue-color);
}

.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent {
  position: relative;
}

.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .input_group {
  padding: 0;
  position: relative;
  border-radius: 10px;
}

.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .input_group .input-btn-submit {
  position: relative;
  top: 0;
}

.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .input_group input:focus {
  outline: 1px solid var(--sdk-chat-window-input-focus-outline) !important;
}

.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .input_group input {
  width: 100%;
  height: 34px;
  padding: 0px 12px 6px 45px;
  font-size: 14px;
  line-height: 1.42857143;
  background-color: var(--sdk-chat-window-bg-color);
  background-image: none;
  border: 1px solid var(--sdk-chat-window-input-border);
  border-radius: 4px;
  z-index: 1;
}

.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .ok_btn {
  position: absolute;
  top: 4px;
  right: 4px;
  height: 26px;
  bottom: 0;
  background: var(--sdk-chat-widow-secondary-font-color);
  padding: 4px 8px;
  border-radius: 4px;
  color: var(--sdk-chat-window-bg-color);
  float: right;
  cursor: pointer;
  z-index: 2;
}

.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .inputMainComponent {
  position: relative;
}

.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent form .hide {
  display: none;
}

.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .btn-group {
  margin: 15px 0 0 0;
  text-align: center;
}

.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .btn-group .btn-info {
  min-width: 80px;
  height: 30px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  margin-right: 10px;
  background-color: #0d6efd;
  border: solid 1px transparent;
  color: #fff;
}

.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .btn-group .btn-url-postback {
  min-width: 80px;
  height: 30px;
  border-radius: 4px;
  font-size: 14px;
  border: solid 1px transparent;
  cursor: pointer;
  margin-right: 10px;
  color: #0d6efd;
}`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/formTemplate/formTemplate.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,0DAAA;AACJ;;AACA;EACI,kBAAA;AAEJ;;AAAA;EACI,UAAA;EACA,kBAAA;EACA,mBAAA;AAGJ;;AADA;EACI,kBAAA;EACA,MAAA;AAIJ;;AAFA;EACI,wEAAA;AAKJ;;AAHA;EACI,WAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,uBAAA;EACA,iDAAA;EACA,sBAAA;EACA,qDAAA;EACA,kBAAA;EACA,UAAA;AAMJ;;AAJA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,sDAAA;EACA,gBAAA;EACA,kBAAA;EACA,sCAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AAOJ;;AALA;EACI,kBAAA;AAQJ;;AANA;EACI,aAAA;AASJ;;AANA;EACI,kBAAA;EACA,kBAAA;AASJ;;AAPA;EACI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,WAAA;AAUJ;;AARA;EACI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAWJ","sourcesContent":[".kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .submitClass{\n    cursor:pointer;\n    width:30px;\n    height:20px;\n    border:1px solid var(--sdk-chat-widow-primary-blue-color);\n}\n.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent{\n    position: relative;\n}\n.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .input_group{\n    padding: 0;\n    position: relative;\n    border-radius: 10px;\n}\n.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .input_group .input-btn-submit{\n    position: relative;\n    top: 0;\n}\n.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .input_group input:focus{\n    outline: 1px solid var(--sdk-chat-window-input-focus-outline)!important;\n}\n.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .input_group input{\n    width: 100%;\n    height: 34px;\n    padding: 0px 12px 6px 45px;\n    font-size: 14px;\n    line-height: 1.42857143;\n    background-color: var(--sdk-chat-window-bg-color);\n    background-image: none;\n    border: 1px solid var(--sdk-chat-window-input-border);\n    border-radius: 4px;\n    z-index:1;\n}\n.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .ok_btn{\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    height: 26px;\n    bottom: 0;\n    background: var(--sdk-chat-widow-secondary-font-color);\n    padding: 4px 8px;\n    border-radius: 4px;\n    color: var(--sdk-chat-window-bg-color);\n    float: right;\n    cursor: pointer;\n    z-index:2;\n}\n.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .inputMainComponent{\n    position: relative;\n}\n.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent form .hide{\n    display:none;\n}\n\n.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .btn-group {\n    margin: 15px 0 0 0;\n    text-align: center;\n}\n.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .btn-group .btn-info {\n    min-width: 80px;\n    height: 30px;\n    border-radius: 4px;\n    font-size: 14px;\n    cursor: pointer;\n    margin-right: 10px;\n    background-color: #0d6efd;\n    border: solid 1px transparent;\n    color: #fff;\n}\n.kore-chat-window .kore-chat-body .buttonTmplContent .formMainComponent .btn-group .btn-url-postback {\n    min-width: 80px;\n    height: 30px;\n    border-radius: 4px;\n    font-size: 14px;\n    border: solid 1px transparent;\n    cursor: pointer;\n    margin-right: 10px;\n    color: #0d6efd;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
